<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <api-grid ref="api-grid" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'ThemePage',
  mixins: [
    methods
  ],
  data () {
    return {
      title: null,
      description: null
    }
  },
  mounted () {
    this.getPage()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/theme.vue